import React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {StyledAccordion} from '@igp/shared/components/accordion';
import {LocalizedText} from '@igp/shared/components/i18n';
import {KeyValueCell, KeyValueColumn, KeyValueTable} from '@igp/shared/components/key-value-table';
import type {UserProfileViewModelKeys} from '@igp/shared/features/user-profile';
import {useUserProfileDetails} from '@igp/shared/features/user-profile';

export const localized = defineMessages({
    title: {
        id: 'PlayerPersonalInfo_title',
        defaultMessage: 'Personal Info',
    },
    username: {
        id: 'PlayerPersonalInfo_username',
        defaultMessage: 'Username',
    },
    nickname: {
        id: 'PlayerPersonalInfo_nickname',
        defaultMessage: 'Nickname',
    },
    email: {
        id: 'PlayerPersonalInfo_email',
        defaultMessage: 'Email',
    },
    phone: {
        id: 'PlayerPersonalInfo_phone',
        defaultMessage: 'Phone Number',
    },
});

type PlayerPersonalInfoProps = {
    uid: string;
};

export function PlayerPersonalInfo({uid}: PlayerPersonalInfoProps) {
    const {formatMessage} = useIntl();
    const userProfileKeys: UserProfileViewModelKeys[] = ['uid', 'nickname', 'username', 'email', 'phone.area', 'phone.number'];
    const {item: user} = useUserProfileDetails({
        id: uid,
        fields: userProfileKeys,
        viewType: 'PersonalInfo',
        displayName: localized.title,
    });
    return (
        <StyledAccordion
            header={<LocalizedText label={localized.title} />}
            componentId="PlayerPersonalInfo"
            children={
                <KeyValueTable>
                    <KeyValueColumn>
                        <KeyValueCell title={formatMessage(localized.username)} withEmptyCheck>
                            {user?.username}
                        </KeyValueCell>
                        <KeyValueCell title={formatMessage(localized.email)} withEmptyCheck>
                            {user?.contact?.email}
                        </KeyValueCell>
                    </KeyValueColumn>
                    <KeyValueColumn>
                        <KeyValueCell title={formatMessage(localized.nickname)} withEmptyCheck>
                            {user?.nickname}
                        </KeyValueCell>
                        <KeyValueCell title={formatMessage(localized.phone)} withEmptyCheck>
                            {user?.contact?.mobile?.area + user?.contact?.mobile?.mobile}
                        </KeyValueCell>
                    </KeyValueColumn>
                </KeyValueTable>
            }
        />
    );
}
